import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'section']
  static values = { match: Array }

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.sourceTarget.value

    this.sectionTargets.forEach(section => {
      const matches = this.matchesFor(section).includes(value)
      section.hidden = !matches
      section.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = !matches })
    })
  }

  matchesFor(section) {
    return section.dataset.match ? JSON.parse(section.dataset.match) : this.matchValue
  }
}
